import store from '../../../store/store';
import { asyncHandler } from '../async-handler';
import { RequestInfo } from '../../../interfaces/RequestInfo';
import { mcpRequestIntegrationUrl, resolveMcpAuth } from './mcp-auth';
import { submitLogToBugsnag } from '../log';

export default async function request_mcp_api_call(
  mcp_name: string,
  mcp_description: string,
  mcp_priority: string
) {
  try {
    const shopSlug = store.getState().user?.company?.shop_slug;
    const auth = resolveMcpAuth();

    const requestInfo: RequestInfo = {
      url: mcpRequestIntegrationUrl(auth, shopSlug),
      method: 'POST',
      body: JSON.stringify({
        mcp_name: mcp_name,
        description: mcp_description,
        priority_level: mcp_priority,
      }),
      headers: {
        Accept: 'application/json',
        'Content-type': 'application/json',
        Authorization: auth.authorization,
      },
    };

    const actionType = 'REQUEST_MCP';
    const customMsg = 'MCP Request Sent Successfully.';

    const res: any = await asyncHandler(requestInfo, actionType, customMsg);

    const response = res?.data;

    if (res?.actionType === actionType && response?.success === true) {
      return true;
    } else {
      return false;
    }
  } catch (exception) {
    console.log('Error during authentication request');
    submitLogToBugsnag('error', `${exception}`);
    return false;
  }
}
